import React, { useState, useEffect } from "react";
import { Form, Spinner } from "react-bootstrap";
import { getPlanOptionsPublic } from "../../intakeApi";

export function PlanOptionSelectorPublic({ schemeCode, value, onChange, isInvalid }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!schemeCode) {
      setOptions([]);
      onChange(null);
      return;
    }
    setLoading(true);
    getPlanOptionsPublic(schemeCode).then((data) => {
      setOptions(data);
      setLoading(false);
    });
  }, [schemeCode]); // eslint-disable-line react-hooks/exhaustive-deps

  function handleChange(e) {
    const selected = options.find(
      (o) => `${o.plan?.code || ""}|${o.option?.code || ""}` === e.target.value
    );
    onChange(selected || null);
  }

  const selectedKey = value
    ? `${value.plan?.code || ""}|${value.option?.code || ""}`
    : "";

  return (
    <div style={{ position: "relative" }}>
      <Form.Select
        value={selectedKey}
        onChange={handleChange}
        disabled={!schemeCode || loading}
        isInvalid={isInvalid}
      >
        <option value="">
          {loading ? "Loading..." : schemeCode ? "Select plan / option" : "Select a medical aid first"}
        </option>
        {options.map((o) => {
          const key = `${o.plan?.code || ""}|${o.option?.code || ""}`;
          const label = [o.plan?.plan, o.option?.option].filter(Boolean).join(" — ");
          return (
            <option key={key} value={key}>
              {label}
            </option>
          );
        })}
      </Form.Select>
      {loading && (
        <Spinner
          size="sm"
          animation="border"
          style={{ position: "absolute", right: 36, top: "50%", transform: "translateY(-50%)" }}
        />
      )}
    </div>
  );
}
